import { usePagination, Pagination as BiPagination, PaginationItem, PaginationButton } from '@bi-digital/react';
import { useSearchParams } from 'react-router';
import { pageSize } from '../../utils';
import { ChevronLeftIcon, ChevronRightIcon } from '@bi-digital/icons';
import styles from './pagination.module.css';
import { useTranslation } from 'react-i18next';

export type PaginationProps = {
    totalResults: number;
};

export const Pagination = ({ totalResults }: PaginationProps) => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const { pages, prevButtonProps, nextButtonProps } = usePagination({
        count: Math.ceil(totalResults / pageSize),
        page: searchParams.has('page') ? Number(searchParams.get('page')) + 1 : 1,
        onPageChange: (page) => {
            setSearchParams((prev) => {
                prev.set('page', String(page - 1)); // Convert to 0-indexed for API
                return prev;
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    });
    return (
        <BiPagination className={styles.pagination}>
            <PaginationItem>
                <PaginationButton aria-label={t('pagination.previousPage')} variant='text' {...prevButtonProps}>
                    <ChevronLeftIcon aria-hidden='true' />
                </PaginationButton>
            </PaginationItem>
            {pages.map(({ page, key, buttonProps }) => (
                <PaginationItem key={key}>
                    {typeof page === 'number' && (
                        <PaginationButton aria-label={t('pagination.page', { page })} {...buttonProps}>
                            {page}
                        </PaginationButton>
                    )}
                </PaginationItem>
            ))}
            <PaginationItem>
                <PaginationButton aria-label={t('pagination.nextPage')} variant='text' {...nextButtonProps}>
                    <ChevronRightIcon aria-hidden='true' />
                </PaginationButton>
            </PaginationItem>
        </BiPagination>
    );
};
